import { cn } from "@/lib/utils"
import { ReactNode } from "react"
import { MaxWidthType } from "../HeroSection"

type ContentContainerProps = {
  children: ReactNode
  className?: string
  maxWidth?: MaxWidthType
}

/**
 * A component that wraps content in a centered, max-width container.
 *
 * This component is typically used for content-heavy pages like blog posts or
 * detailed articles ([...slug] pages) where the content needs to be constrained
 * to a readable line length.
 *
 * For full-width sections containing grids, use the `ContentSection` component instead.
 *
 * @param {ReactNode} children The content to be rendered inside the container.
 * @param {string} [className] Optional additional classes to apply.
 * @param {MaxWidthType} [maxWidth="5xl"] The maximum width of the container.
 */
export function ContentContainer({
  children,
  className = "",
  maxWidth = "5xl",
}: ContentContainerProps) {
  const actualClassName = cn(className, "mx-auto p-0", `max-w-${maxWidth}`)

  return <div className={actualClassName}>{children}</div>
}
